"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionTabNavigationItem = exports.TabNavigationItem = exports.TabNavigationItems = exports.TabNavigationContainer = void 0;
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
require("./TabNavigation.pc.css");
const TabNavigationContainer = ({ dataTestId, slim, horizontal, paddingBottom, noPadding, children, }) => {
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('_60d0a316', '_d7884502', '_pub-d7884502', '_pub-3c25d522', {
            '_d7884502_slim _pub-d7884502_slim _pub-3c25d522_slim slim': slim,
            '_d7884502_horizontal _pub-d7884502_horizontal _pub-3c25d522_horizontal horizontal': horizontal,
            '_d7884502_paddingBottom _pub-d7884502_paddingBottom _pub-3c25d522_paddingBottom paddingBottom': paddingBottom,
            '_d7884502_no-padding _pub-d7884502_no-padding _pub-3c25d522_no-padding no-padding': noPadding,
        }), "data-testid": dataTestId }, children));
};
exports.TabNavigationContainer = TabNavigationContainer;
const TabNavigationItems = ({ testId, className, children, controls, }) => {
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('_8edec23a', '_d7884502', '_pub-d7884502', '_pub-3c25d522', className), "data-testid": testId },
        react_1.default.createElement("div", { className: (0, clsx_1.default)('_17e98b87', '_d7884502', '_pub-d7884502', '_pub-3c25d522') },
            react_1.default.createElement("div", { className: (0, clsx_1.default)('_3e850be7', '_d7884502', '_pub-d7884502', '_pub-3c25d522') },
                react_1.default.createElement("div", { className: (0, clsx_1.default)('_b6c0ca0c', '_d7884502', '_pub-d7884502', '_pub-3c25d522') }, children),
                react_1.default.createElement("div", { className: (0, clsx_1.default)('_2fc99bb6', '_d7884502', '_pub-d7884502', '_pub-3c25d522') }, controls)),
            react_1.default.createElement("div", { className: (0, clsx_1.default)('_d08b6acb', '_d7884502', '_pub-d7884502', '_pub-3c25d522') }))));
};
exports.TabNavigationItems = TabNavigationItems;
const TabNavigationItem = ({ testId, tagName, onClick, to, className, p2, active, hover, inactive, children, }) => {
    const Root = (_a) => {
        var { children } = _a, rootProps = __rest(_a, ["children"]);
        return react_1.default.createElement(tagName || 'button', rootProps, children);
    };
    return (react_1.default.createElement(Root, { className: (0, clsx_1.default)('_6966ef3d', '_d7884502', '_pub-d7884502', '_pub-3c25d522', '_d7884502_text-body-medium', '_pub-d7884502_text-body-medium', '_pub-3c25d522_text-body-medium', 'text-body-medium', {
            '_d7884502_p2 _pub-d7884502_p2 _pub-3c25d522_p2 p2': p2,
            '_d7884502_active _pub-d7884502_active _pub-3c25d522_active active': active,
            '_d7884502_hover _pub-d7884502_hover _pub-3c25d522_hover hover': hover,
            '_d7884502_inactive _pub-d7884502_inactive _pub-3c25d522_inactive inactive': inactive,
        }, className), "data-testid": testId, onClick: onClick, to: to },
        react_1.default.createElement("div", { className: (0, clsx_1.default)('_f379c7a1', '_d7884502', '_pub-d7884502', '_pub-3c25d522') }),
        children));
};
exports.TabNavigationItem = TabNavigationItem;
const AccordionTabNavigationItem = ({ testId, onClick, active, label, hover, expanded, onExpandClick, children, }) => {
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('_7d184e96', '_d7884502', '_pub-d7884502', '_pub-3c25d522') },
        react_1.default.createElement("button", { className: (0, clsx_1.default)('_f15544af', '_d7884502', '_pub-d7884502', '_pub-3c25d522', '_d7884502_text-body-medium', '_pub-d7884502_text-body-medium', '_pub-3c25d522_text-body-medium', 'text-body-medium', {
                '_d7884502_active _pub-d7884502_active _pub-3c25d522_active active': active,
            }), "data-testid": testId, onClick: onClick },
            react_1.default.createElement("div", { className: (0, clsx_1.default)('_68039cd0', '_d7884502', '_pub-d7884502', '_pub-3c25d522') },
                label,
                react_1.default.createElement("button", { className: (0, clsx_1.default)('_d1a56be3', '_d7884502', '_pub-d7884502', '_pub-3c25d522', {
                        '_d7884502_hover _pub-d7884502_hover _pub-3c25d522_hover hover': hover,
                        '_d7884502_expanded _pub-d7884502_expanded _pub-3c25d522_expanded expanded': expanded,
                    }), onClick: onExpandClick }))),
        react_1.default.createElement("div", { className: (0, clsx_1.default)('_1f5b2583', '_d7884502', '_pub-d7884502', '_pub-3c25d522', {
                '_d7884502_expanded _pub-d7884502_expanded _pub-3c25d522_expanded expanded': expanded,
            }) }, children)));
};
exports.AccordionTabNavigationItem = AccordionTabNavigationItem;
//# sourceMappingURL=TabNavigation.js.map